<template>
  <RevTag
    :label="props.competitionLevel.label"
    size="medium"
    :variant="competitionLevelVariantMapping[props.competitionLevel.value]"
  />
</template>

<script setup lang="ts">
import { RevTag } from '@ds/components/Tag'

import type { ListingV2 } from '~/api/listings/types'

import type { CompetitionLevelVariationMapping } from './CompetitionTag.types'

const props = defineProps<{
  competitionLevel: ListingV2['competitionLevel']
}>()

const competitionLevelVariantMapping: CompetitionLevelVariationMapping = {
  VERY_LOW: 'info',
  LOW: 'info',
  MEDIUM: 'warning',
  NONE: 'primary',
}
</script>
